import { Injectable, Injector } from '@angular/core';
import { WkCardItemTypeService } from './wk-card-item-type.service';

import { WkCardViewUpdateService } from './wk-card-view-update.service';
import { WkContentManagementService } from './wk-content-management.service';
import { WkContentMetadataService } from './wk-content-metadata.service';

@Injectable({
  providedIn: 'root',
})
export class CoreContentService {
  get cardViewUpdateInstance() {
    return this.wkCardViewUpdateService;
  }
  get metadataInstance() {
    return this.wkContentMetadataService;
  }
  get cardItemTypeInstance() {
    return this.WkCardItemTypeService;
  }
  get contentManagementInstance() {
    return this.wkContentManagementService;
  }
  private readonly wkCardViewUpdateService: WkCardViewUpdateService;
  private readonly wkContentMetadataService: WkContentMetadataService;
  private readonly WkCardItemTypeService: WkCardItemTypeService;
  private readonly wkContentManagementService: WkContentManagementService;
  constructor(injector: Injector) {
    this.wkCardViewUpdateService = injector.get<WkCardViewUpdateService>(
      WkCardViewUpdateService
    );
    this.wkContentMetadataService = injector.get<WkContentMetadataService>(
      WkContentMetadataService
    );
    this.WkCardItemTypeService = injector.get<WkCardItemTypeService>(
      WkCardItemTypeService
    );
    this.wkContentManagementService = injector.get<WkContentManagementService>(
      WkContentManagementService
    );
  }
}
